import { inject, Service } from '@angular/core';
import { AjaxCallService } from './ajax-call';
import { CurrentUser, NeoPermission, NeoPermissionGroup } from '../models/current-user.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Service()
export class CurrentUserService {

    private ajax = inject(AjaxCallService);
    private router = inject(Router);

    private _currentUserWatch = new BehaviorSubject<CurrentUser | null>(null);

    public currentUser(): Observable<CurrentUser | null> {
        return this._currentUserWatch;
    }

    private currentValue: CurrentUser | null = null;

    get(): Observable<CurrentUser | null> {
        this.ajax.MakeCall<CurrentUser>('/Account/Current')
            .then((x) => {
                this.currentValue = x;
                this._currentUserWatch.next(x);
            }, () => {
                this._currentUserWatch.error(false);
            });

        return this.currentUser();
    }

    validate(permission: NeoPermission, group: NeoPermissionGroup): void {
        if (!this.check(permission, group)) {
            this.router.navigate(['/']);
            return;
        }
    }

    check(permission: NeoPermission, group: NeoPermissionGroup): boolean {
        if (!this.currentValue) {
            return false;
        }
        if (this.currentValue.permissions.filter(x => x.groupId == group && x.permissionId == permission).length == 0) {
            return false;
        }
        return true;
    }
}

